export const formatTimestamp = (timestamp) => {
    if (!timestamp) {
        return "";
    }
    const date = new Date(timestamp);
    const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${dayOfWeek} ${day}. ${month}. ${year} at ${hours}:${minutes}`;
};
export const formatShortTimestamp = (timestamp) => {
    if (!timestamp) {
        return "";
    }
    const date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString().slice(-2);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
};
export const getDateFromTimestamp = (timestamp) => {
    if (!timestamp) {
        return "";
    }
    const date = new Date(timestamp);
    return `${date.getDay()}. ${date.getMonth() + 1}. ${date.getFullYear()}`;
};
export const getTimeFromTimestamp = (timestamp) => {
    if (!timestamp) {
        return "";
    }
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
};
// function masks the middle parts of UUID with asterisks
export const maskUuid = (uuid) => {
    if (!uuid) {
        return "";
    }
    return `${uuid.slice(0, 8)}...`;
};
export const formatIban = (iban, prefix = 4, suffix = 4) => {
    if (iban.length < prefix + suffix) {
        return iban;
    }
    const start = iban.slice(0, prefix);
    const end = iban.slice(-suffix);
    return `${start} **** **** ${end}`;
};
